/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 21/05/2025 | Lic. José Luis Aragón Cervantes  | Creación
* --------------------------------------------------------------------------------------- 
*/

import TextField from "../ui/TextField";
import React, { Fragment, useState, useEffect, useRef } from "react";
import { NumericFormat } from 'react-number-format';
import { AttachMoney, CreditCard, AccountBalance, CallToAction, AccountBalanceWallet, Scale } from '@mui/icons-material'; // Importa los íconos que necesites

import { Modal, Box, Tooltip, IconButton, Zoom } from "@mui/material";
import { NumberFormat$ } from "../../settings/utils";
import { useVentas } from '../../context/Ventas/VentasContext'

import { height } from "@mui/system";
import { dateTimeValue } from "docx";

// Estilos para el modal con efecto suavizado de desplazamiento
const modalStyle = {
    Scale:'90%',
    position: 'fixed',
    top: '3%',
    right: '33%',
    width: '30vw',
    height:'690px',
    maxWidth: '82vw',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    display: 'flex',
    flexDirection: 'column',
    transform: 'translateX(300%)',
    transition: 'transform 0.5s ease-in-out',
    overflowY: 'auto',
    overflowX: 'auto',
};

const listaTiposMonedas = [
    {"TIPO":"MONEDA", "VALOR": ".50", "Cantidad":0},
    {"TIPO":"MONEDA", "VALOR": "1", "Cantidad":0},
    {"TIPO":"MONEDA", "VALOR": "2", "Cantidad":0},
    {"TIPO":"MONEDA", "VALOR": "5", "Cantidad":0},
    {"TIPO":"MONEDA", "VALOR": "10", "Cantidad":0},
    {"TIPO":"BILLETE", "VALOR": "20", "Cantidad":0},
    {"TIPO":"BILLETE", "VALOR": "50", "Cantidad":0},
    {"TIPO":"BILLETE", "VALOR": "100", "Cantidad":0},
    {"TIPO":"BILLETE", "VALOR": "200", "Cantidad":0},
    {"TIPO":"BILLETE", "VALOR": "500", "Cantidad":0},
    {"TIPO":"BILLETE", "VALOR": "1000", "Cantidad":0}
]

export default function ModalCorteCaja(props) {
    const {openModalVisorCortes = false, handleCloseModalVisorCortes, caja = 'CAAJ1', fechaCorte = Date.now, usuario = "ALL", handleGenerarCorteCaja} = props;

    const [internalOpen, setInternalOpen] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [listadoMonedas, setListadoMonedas] = useState(listaTiposMonedas);
    const primerInputRef = useRef(null);

    const handleUpdateListaMonedas = async (tipo, valor, e) => {
        const updatedList = listadoMonedas.map((item) =>
            item.TIPO === tipo && item.VALOR === valor
                ? { ...item, Cantidad: parseFloat(e.target.value) || 0 }
                : item
        );
        await setListadoMonedas(updatedList);
    };

    const handleGenerarCorteDetalles=(caja, fechaCorte, usuario, listaTiposMonedas)=>{
        
    };

    // Efecto para manejar la apertura/cierre con retardo para permitir la animación
    useEffect(() => {
        if (openModalVisorCortes) {
            setInternalOpen(true);
            setListadoMonedas(listaTiposMonedas.map(m => ({ ...m, Cantidad: 0 })));
            setTimeout(() => {
                setModalVisible(true);
            }, 50);
            setTimeout(() => {
                if (primerInputRef.current) {
                    primerInputRef.current.focus();
                    primerInputRef.current.select();
                }
            }, 100);
        } else {
            setModalVisible(false);
            setTimeout(() => {
                setInternalOpen(false);
            }, 500);
        }
    }, [openModalVisorCortes]);

    const modalVisibleStyle = {
        transform: modalVisible ? 'translateX(0)' : 'translateX(300%)',
    };

    return (
        <Modal
            open={internalOpen}
            onClose={handleCloseModalVisorCortes}
            aria-labelledby="menu-modal-title"
            aria-describedby="menu-modal-description"
            closeAfterTransition
        >
            <Box sx={{ ...modalStyle, ...modalVisibleStyle }}>
                <Fragment>
                    <div className="detalles-totales-header">
                        <h2>Corte caja</h2>
                    </div>
                    <div>
                        {listadoMonedas?.map((moneda, index) => (
                            <div key={index} className="detalles-totales-efectivo">
                                <p>{moneda.TIPO} - $ {moneda.VALOR}</p>
                                <NumericFormat
                                    inputRef={index === 0 ? primerInputRef : null}
                                    value={moneda.Cantidad}
                                    thousandSeparator={true}
                                    prefix="Pzas "
                                    decimalScale={2}
                                    fixedDecimalScale
                                    customInput={TextField}
                                    label="Cantidad"
                                    sx={{ zoom:'72%', margin:'-9px', width: '250px'}}
                                    disabled={false}
                                    onValueChange={(values) => {
                                        handleUpdateListaMonedas(moneda.TIPO, moneda.VALOR, {
                                            target: { value: values.value }
                                        });
                                    }}
                                />
                            </div>
                        ))}
                    </div>
                    <div>
                        <button className="boton-generar" onClick={(caja, fechaCorte, usuario, listaTiposMonedas) => handleGenerarCorteDetalles()} style={{ backgroundColor: '#a9701e', color: '#FFFFFF' }}>Generar corte</button> 
                    </div>
                </Fragment>
            </Box>
        </Modal>
      );
  }